import { JsonObject, JsonProperty } from "ta-json";

import type { MapCultureTo } from "../../base-types";

@JsonObject()
export class SortingResponseResource {
    @JsonProperty("name")
    fieldName: string;

    @JsonProperty("labels")
    labels: MapCultureTo<string>;

    @JsonProperty("asc")
    ascending: boolean = false;
}
